<template>
<q-page class="main">
  <common-form :action="$route('theme.update', {thema: theme.id})" is-update>
    <q-card class="page-card">
      <q-card-section class="page-card__main-content">
        <item-header :item="theme" />
        <theme-form :theme="theme" />
      </q-card-section>
      <q-separator />
      <q-card-actions align="right" class="q-pa-md">
        <warning-button label="Verwijder" @click="deleteTheme" />
        <accent-button label="Opslaan" type="submit" />
      </q-card-actions>
    </q-card>
  </common-form>
  <sticky-top-bar />
</q-page>
</template>

<script>
import ThemeForm from './ThemeForm'
import StickyTopBar from '../../components/layout/StickyTopBar'

export default {
  components: {
    StickyTopBar,
    ThemeForm,
  },
  props: {
    theme: {
      type: Object,
      default: () => ({}),
    },
    themes: {
      type: Object,
      default: () => ({}),
    },
    otherPhases: {
      type: Array,
      default: () => ({}),
    },
  },
  data() {
    return {
      targetPhaseId: null,
    }
  },
  methods: {
    async deleteTheme() {
      if (!await this.$confirm({ title: 'Weet u zeker dat u dit thema wilt verwijderen?' })) {
        return
      }
      try {
        await axios.delete(this.$route('theme.destroy', { thema: this.theme.id }))
        this.$toast('success', 'Het thema is verwijderd')
        this.$goto('theme.index')
      } catch (e) {
        console.error(e)
        this.$toast('error', 'Het thema kon niet worden verwijderd')
      }
    },
  },
}
</script>
